import { home } from "@/content";
import { Rich } from "@/lib/rich";

export default function LightCases() {
  const { cases: section } = home;

  return (
    <section id="cases" className="py-24 bg-white dark:bg-[#0E0E0E] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] left-[-5%] w-[450px] h-[450px] rounded-full bg-orange-200/25 dark:bg-orange-500/[0.12] blur-[140px]" />
        <div className="absolute bottom-[8%] right-[-3%] w-[400px] h-[400px] rounded-full bg-green-300/20 dark:bg-green-500/10 blur-[130px]" />
        <div className="absolute top-[45%] left-[40%] w-[350px] h-[350px] rounded-full bg-violet-300/18 dark:bg-violet-500/10 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-stone-100 dark:bg-white/[0.06] text-stone-600 dark:text-white/70 text-xs font-semibold tracking-widest uppercase mb-4">
            {section.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 dark:text-white mb-4">
            <Rich text={section.title} accentClassName="text-orange-700 dark:text-orange-400" />
          </h2>
          {section.subtitle && (
            <p className="text-stone-600 dark:text-white/65 text-lg">{section.subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.items.map((item) => (
            <div
              key={item.industry}
              className="bg-gradient-to-br from-amber-50/60 dark:from-orange-500/[0.08] to-orange-50/30 dark:to-transparent border border-stone-100 dark:border-white/[0.08] rounded-2xl p-6 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-300 cursor-default"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-orange-400">
                    <i className={`${item.icon} text-white text-base`}></i>
                  </div>
                  <div className="font-bold text-stone-900 dark:text-white text-sm">
                    {item.industry}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-green-700 dark:text-green-400 font-extrabold text-sm">
                    {item.result}
                  </div>
                  <div className="text-stone-600 dark:text-white/65 text-xs">{item.period}</div>
                </div>
              </div>

              <p className="text-stone-600 dark:text-white/65 text-sm leading-relaxed mb-4">
                {item.desc}
              </p>

              <div className="grid grid-cols-2 gap-2">
                {item.metrics.map((metric) => (
                  <div
                    key={metric.label}
                    className="bg-white dark:bg-white/[0.04] rounded-xl p-3 border border-stone-100 dark:border-white/[0.08]"
                  >
                    <div className="text-stone-600 dark:text-white/65 text-[10px] mb-1">
                      {metric.label}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-stone-600 dark:text-white/50 text-xs line-through">
                        {metric.before}
                      </span>
                      <i className="ri-arrow-right-line text-stone-600 dark:text-white/50 text-[10px]"></i>
                      <span className="text-stone-900 dark:text-white font-bold text-xs">
                        {metric.after}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
